'use client';

import { useEffect, useState } from 'react';

export default function ProfileAvatar({
  src,
  alt = '',
  fallback,
  size = 96,
  className = '',
  imageClassName = '',
  priority = false,
}) {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => setImageFailed(false), [src]);

  return (
    <div className={`relative overflow-hidden rounded-full ${className}`}>
      {src && !imageFailed ? (
        // Avatar URLs are versioned same-origin proxy URLs. A native image is
        // intentionally used here so cache-busting query strings do not depend
        // on Next Image localPatterns and remain reliable after an upload.
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={src}
          alt={alt}
          width={size}
          height={size}
          loading={priority ? 'eager' : 'lazy'}
          decoding="async"
          fetchPriority={priority ? 'high' : 'auto'}
          referrerPolicy="no-referrer"
          className={`absolute inset-0 h-full w-full object-cover ${imageClassName}`}
          onError={() => setImageFailed(true)}
        />
      ) : fallback}
    </div>
  );
}
